<table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortData($event)" width="100%">
    <ng-container *ngFor="let c of columns" [matColumnDef]="c.columnDef">
        <ng-container>
          <th mat-header-cell *matHeaderCellDef>
            {{c.header}}
          </th>
        </ng-container>
        <td mat-cell *matCellDef="let element">
          {{element[c.columnDef]}}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;"></tr>
  </table>